import React from 'react';
import { observer } from 'mobx-react';
import { IContainerProps } from './IContainerProps';
import CloseDeviceSettingsComponent from './Close-device-settings.component';
import useCloseDeviceSettings from './useCloseDeviceSettings';

const Container: React.FC<IContainerProps> = ({
    onClick,
    onClose,
    onConfirm,
    onCancel,
}: IContainerProps) => {
    const { lang, handlers } = useCloseDeviceSettings({ onConfirm, onCancel, onClick, onClose });

    return (
        <>
            <CloseDeviceSettingsComponent
                lang={lang.lang}
                onConfirmClick={handlers.handleConfirmClick}
                onCancelClick={handlers.handleCancelClick}
            />
        </>
    );
};

const CloseDeviceSettingsContainer = observer(Container);

export default CloseDeviceSettingsContainer;
